<template>
  <div class="forgot-password-container">
    <v-card class="forgot-password-card" :loading="isLoadingOtp" elevation="0">
      <v-card-text class="px-8 py-6">
        <!-- Header with back button and title -->
        <div class="form-header d-flex align-center mb-6">
          <v-btn icon small @click="gotoLoginTab(0)" class="back-btn me-3">
            <v-icon color="#6B7280" size="20">mdi-chevron-left</v-icon>
          </v-btn>
          <h1 class="forgot-title">{{ forgotPasswordTitle }}</h1>
        </div>
        
        <v-form class="mt-2">
          <!-- Email Field -->
          <div class="form-group mb-6">
            <label class="field-label">{{ emailOTP }}</label>
            <div class="input-container">
              <v-text-field
                  color="#4A90E2"
                  dense
                  outlined
                  v-model="email"
                  autocomplete="username email"
                  :placeholder="enterEmail"
                  name="email"
                  class="custom-input"
                  hide-details="auto">
                <template v-slot:prepend-inner>
                  <v-icon color="#9CA3AF" size="20">mdi-email-outline</v-icon>
                </template>
              </v-text-field>
            </div>
            <div v-if="!validUser" class="text-valid-error mt-1">{{ validUserDetail }}</div>
          </div>

          <!-- Info Section -->
          <div class="info-section mb-8 d-flex align-start">
            <v-icon color="#4A90E2" size="20" class="me-2 mt-1">mdi-information-outline</v-icon>
            <div class="info-text">{{ infoTitle }}</div>
          </div>

          <!-- Send OTP Button -->
          <v-btn
              type="button"
              block
              large
              class="send-btn"
              :disabled="btSendDisabled"
              :loading="isLoadingOtp"
              color="#4A90E2"
              @click="sendCodeOTP">
            {{ sendOTP }}
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import i18n from "../../../lang/i18n";
import {API2} from "../../../api";
import store from "../../../store";
import mixin from "../../../mixin";


export default {
  mixins: [mixin],
  props: {
    gotoLoginTab: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      email: "",
      emailTemp: "",
      errorToastTitle: "",
      isLoadingOtp: false,
      validUser: true,
    };
  },
  computed: {
    emailOTP: () => i18n.t("login.emailOTP"),
    enterEmail: () => i18n.t("account.enterEmail"),
    forgotPasswordTitle: () => i18n.t("login.forgotPasswordTitle"),
    sendOTP: () => i18n.t("login.sendOTP"),
    infoTitle: () => i18n.t("login.infoTitle"),
    btSendDisabled: function () {
      let emailNotChanged = this.email === this.emailTemp
      return !this.email || emailNotChanged
    },
  },
  methods: {
    async sendCodeOTP() {
      let res = await this.post(API2.SEND_OTP, {
        email: this.email
      }, "isLoadingOtp");
      if (!res) {
        this.emailTemp = this.email;
        return
      }
      this.showToast('success', i18n.t("ui.confirmationCodeSent"), res.message)
      await store.dispatch("setAccountReceiveOtp", this.email);
      this.gotoLoginTab(2)
    },
  }

}
</script>

<style scoped>
/* Container Styling - Same as Login Form */
.forgot-password-container {
  width: 100%;
  margin: 0 auto;
}

.forgot-password-card {
  background: #ffffff;
  border-radius: 16px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
}

.forgot-password-card >>> .v-card__text {
  padding: 2rem 1.5rem !important;
}

/* Form Header */
.form-header {
  margin-bottom: 2rem !important;
}

.forgot-title {
  font-size: 28px;
  font-weight: 700;
  color: #1F2937;
  margin: 0;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

.back-btn {
  background-color: rgba(107, 114, 128, 0.1) !important;
}

.back-btn:hover {
  background-color: rgba(74, 144, 226, 0.1) !important;
}

/* Form Group Styling - Same as Login Form */
.form-group {
  margin-bottom: 1.25rem;
}

.field-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

/* Input Container */
.input-container {
  position: relative;
}

/* Custom Input Styling - Same as Login Form */
.custom-input >>> .v-input__control {
  min-height: 48px !important;
}

.custom-input >>> .v-text-field__details {
  display: none;
}

.custom-input >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F9FAFB !important;
  border: 1px solid #E5E7EB !important;
  transition: all 0.2s ease;
}

.custom-input >>> .v-input__slot:hover {
  border-color: #4A90E2 !important;
  background: #ffffff !important;
}

.custom-input >>> .v-input__slot.v-input--is-focused {
  border-color: #4A90E2 !important;
  border-width: 2px !important;
  background: #ffffff !important;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1) !important;
}

.custom-input >>> .v-text-field__slot input {
  padding: 12px 16px;
  font-size: 14px;
  color: #374151;
}

.custom-input >>> .v-text-field__slot input::placeholder {
  color: #9CA3AF;
  font-size: 14px;
}

/* Error State */
.text-valid-error {
  color: #EF4444;
  font-size: 12px;
  font-weight: 500;
}

/* Info Section */
.info-section {
  background-color: #F0F9FF;
  border: 1px solid #BAE6FD;
  border-radius: 8px;
  padding: 12px;
}

.info-text {
  font-size: 14px;
  color: #0369A1;
  line-height: 1.4;
}

/* Send Button - Same as Login Form */
.send-btn {
  background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%) !important;
  border: 1px solid #4A90E2 !important;
  border-radius: 8px !important;
  height: 48px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.25) !important;
  transition: all 0.2s ease !important;
  color: #ffffff !important;
}

.send-btn:hover:not(:disabled) {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 20px rgba(74, 144, 226, 0.35) !important;
  background: linear-gradient(135deg, #357ABD 0%, #2968A3 100%) !important;
  border-color: #357ABD !important;
}

.send-btn:active:not(:disabled) {
  transform: translateY(0) !important;
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.25) !important;
}

.send-btn.v-btn--disabled {
  background: #F3F4F6 !important;
  color: #9CA3AF !important;
  border: 1px solid #E5E7EB !important;
  box-shadow: none !important;
}

.send-btn >>> .v-btn__loader {
  color: #ffffff;
}

/* Responsive Design */
@media (max-width: 480px) {
  .forgot-password-container {
    margin: 0 16px;
 
  }
  
  .forgot-password-card >>> .v-card__text {
    padding: 1.5rem 1.25rem !important;
  }
  
  .field-label {
    font-size: 13px;
  }
  
  .forgot-title {
    font-size: 24px;
  }
}

/* Animation for form elements */
.form-group {
  animation: slideInUp 0.3s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-group:nth-child(1) { animation-delay: 0.1s; }
.info-section { animation: slideInUp 0.3s ease-out 0.2s both; }
.send-btn { animation: slideInUp 0.3s ease-out 0.3s both; }
</style>
